import React, { lazy, memo } from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
const URL_BUNDLE = 'https://mentecheck.librosdigitales.pro/cart/46850256437387:1';
export function HistoriasPunoYLetra() {
  const inside = [{
    title: 'Página de Portada Personalizada',
    desc: 'Con espacio para foto, nombre y fecha de inicio.'
  }, {
    title: 'Carta de Dedicatoria del Familiar',
    desc: 'Para que vos le escribas el "por qué" de este regalo antes de entregárselo.'
  }, {
    title: '6 Estaciones de Vida',
    desc: 'Desde la infancia sensorial hasta el legado final, con preguntas que despiertan recuerdos profundos y espacios amplios para escribir con comodidad.'
  }, {
    title: 'Disparadores Emocionales en cada página',
    desc: 'Preguntas diseñadas para que no haya "no sé qué escribir". Cada consigna lleva la memoria hacia imágenes concretas y sentimientos reales.'
  }, {
    title: 'El Cierre Bomba',
    desc: 'Una página entera dedicada a la frase que resume toda una vida. Su letra. Su firma. Su sello para la eternidad.'
  }, {
    title: 'La Página "El Puente"',
    desc: 'Una sección especial para completar entre el adulto mayor y un familiar juntos. Preguntas de ida y vuelta que generan una conversación que quizás nunca tuvieron.'
  }];
  const forWho = [{
    emoji: '👴',
    text: 'Para el abuelo que tiene mil historias y nunca nadie le preguntó cuáles son.'
  }, {
    emoji: '👵',
    text: 'Para la abuela que cocinó para todos pero nunca contó de dónde venía esa receta.'
  }, {
    emoji: '👨\u200d👩\u200d👧',
    text: 'Para la familia que quiere tener algo concreto, escrito de su puño y letra, para guardar y releer cuando el tiempo pase.'
  }];
  const howToUse = ['Lo imprimís y se lo entregás.', 'Ellos eligen un momento tranquilo, se preparan un mate o un café y empiezan a escribir.', 'No hay orden obligatorio. No hay respuestas correctas. No hay apuro.', 'Cuando terminen, tenés en tus manos el libro más valioso de tu casa.'];
  return <section className="py-16 md:py-20 px-4 bg-[#EFE4CC] border-y border-orange-200" data-id="element-169">
      <div className="max-w-5xl mx-auto" data-id="element-170">
        {/* Header with image + emotional opening */}
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-12" data-id="element-171">
          <div className="flex justify-center order-2 md:order-1" data-id="element-172">
            <a href={URL_BUNDLE} className="block" data-id="element-173">
              <img src="https://cdn.magicpatterns.com/uploads/tKpBxjWS41Muz72cLKTeiU/cuadernillo_historias_de_vida-removebg-preview.png" alt="Cuadernillo Historias de mi puño y letra" loading="lazy" className="w-full max-w-xs md:max-w-sm h-auto cursor-pointer drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-174" />
            </a>
          </div>

          <div className="order-1 md:order-2" data-id="element-175">
            <div className="inline-flex items-center gap-2 bg-orange-200 text-orange-700 font-bold px-4 py-1.5 rounded-full text-xs tracking-widest mb-4" data-id="element-176">
              <Sparkles className="w-3.5 h-3.5" data-id="element-177" /> SUMÁ A TU PEDIDO
            </div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 leading-tight mb-4" data-id="element-178">
              Además vas a recibir un recurso especial pensado para algo más que
              la memoria
            </h2>
            <p className="text-base md:text-lg text-slate-700 leading-relaxed mb-4" data-id="element-179">
              💛 ¿Sabés cuántas historias de tu familia se perdieron simplemente
              porque nadie las escribió a tiempo?
            </p>
            <p className="text-base md:text-lg text-slate-700 leading-relaxed font-semibold mb-3" data-id="element-180">
              Son preguntas simples y profundas:
            </p>
            <ul className="space-y-2 text-sm md:text-base text-slate-700 mb-5" data-id="element-181">
              <li className="flex items-start gap-2" data-id="element-182">
                <span className="text-teal-600 shrink-0" data-id="element-183">✦</span>
                <span data-id="element-184">Revive recuerdos de la infancia</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-185">
                <span className="text-teal-600 shrink-0" data-id="element-186">✦</span>
                <span data-id="element-187">Conecta momentos importantes de su vida</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-188">
                <span className="text-teal-600 shrink-0" data-id="element-189">✦</span>
                <span data-id="element-190">Estimula la memoria de forma natural</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-191">
                <span className="text-teal-600 shrink-0" data-id="element-192">✦</span>
                <span data-id="element-193">Fortalece el vínculo familiar</span>
              </li>
            </ul>
            <p className="text-lg md:text-xl text-orange-700 leading-snug text-center md:text-left" style={{
            fontFamily: '"Playfair Display", Georgia, serif',
            fontStyle: 'italic',
            fontWeight: 700
          }} data-id="element-194">
              Un legado que te va a quedar de recuerdo para siempre.
            </p>
          </div>
        </div>

        {/* Body copy */}
        <div className="max-w-3xl mx-auto space-y-5 text-base md:text-lg text-slate-700 leading-relaxed mb-10" data-id="element-195">
          <p data-id="element-196">
            Un cuadernillo imprimible de recuerdos familiares para compartir
            momentos, historias y experiencias con tus seres queridos.
          </p>
          <p className="font-semibold text-slate-900" data-id="element-197">
            Un espacio para escribir, recordar y conectar.
          </p>
          <p className="text-teal-700 font-medium italic" data-id="element-198">
            Porque estimular la mente también es mantener vivos los recuerdos
            que importan.
          </p>
        </div>

        {/* What's inside */}
        <div className="bg-white border border-orange-200 rounded-2xl p-6 md:p-10 shadow-md mb-8 max-w-3xl mx-auto" data-id="element-199">
          <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-6 text-center" data-id="element-200">
            ¿Qué tiene adentro?
          </h3>
          <ul className="space-y-5" data-id="element-201">
            {inside.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-202">
                <span className="text-teal-600 font-bold text-lg shrink-0 mt-0.5" data-id="element-203">
                  ✅
                </span>
                <div data-id="element-204">
                  <p className="font-bold text-slate-900 mb-1" data-id="element-205">{item.title}</p>
                  <p className="text-sm md:text-base text-slate-600 leading-relaxed" data-id="element-206">
                    {item.desc}
                  </p>
                </div>
              </li>)}
          </ul>
        </div>

        {/* Who is it for */}
        <div className="bg-white border border-orange-200 rounded-2xl p-6 md:p-10 shadow-md mb-8 max-w-3xl mx-auto" data-id="element-207">
          <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-6 text-center" data-id="element-208">
            ¿Para quién es este cuadernillo?
          </h3>
          <ul className="space-y-4" data-id="element-209">
            {forWho.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-slate-700" data-id="element-210">
                <span className="text-2xl shrink-0" data-id="element-211">{item.emoji}</span>
                <span className="text-base md:text-lg leading-relaxed" data-id="element-212">
                  {item.text}
                </span>
              </li>)}
          </ul>
        </div>

        {/* How to use */}
        <div className="bg-white border border-orange-200 rounded-2xl p-6 md:p-10 shadow-md mb-10 max-w-3xl mx-auto" data-id="element-213">
          <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-6 text-center" data-id="element-214">
            ¿Cómo se usa?
          </h3>
          <ol className="space-y-4" data-id="element-215">
            {howToUse.map((step, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-216">
                <span className="shrink-0 w-9 h-9 rounded-full bg-teal-600 text-white font-bold flex items-center justify-center text-sm" data-id="element-217">
                  {idx + 1}
                </span>
                <span className="text-base md:text-lg text-slate-700 leading-relaxed pt-1" data-id="element-218">
                  {step}
                </span>
              </li>)}
          </ol>
        </div>

        {/* Emotional closing + CTA */}
        <div className="max-w-3xl mx-auto text-center bg-gradient-to-b from-orange-50 to-white border-2 border-orange-300 rounded-3xl p-6 md:p-10 shadow-xl" data-id="element-219">
          <p className="text-2xl md:text-3xl font-extrabold text-slate-900 mb-3" data-id="element-220">
            💎 No es un gasto. Es una herencia.
          </p>
          <p className="text-base md:text-lg text-slate-700 leading-relaxed mb-2" data-id="element-221">
            Por solo $9.990 ARS extra estás asegurando que la voz, la letra y
            los recuerdos de tu ser querido no se pierdan nunca.
          </p>
          <p className="text-sm md:text-base text-slate-600 italic mb-8" data-id="element-222">
            Una vez que ya no estén, ningún precio va a poder traer de vuelta lo
            que no se escribió a tiempo.
          </p>

          <button onClick={() => {
          window.dispatchEvent(new CustomEvent('select-checkout-option', {
            detail: 'bundle'
          }));
          setTimeout(() => {
            document.getElementById('checkout')?.scrollIntoView({
              behavior: 'smooth'
            });
          }, 50);
        }} className="inline-flex items-center justify-center gap-2 w-full md:w-auto bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-8 rounded-xl text-base md:text-xl transition-all duration-300 transform hover:scale-105 shadow-lg" data-id="element-223">
            QUIERO EL CUADERNILLO HISTORIAS DE MI PUÑO Y LETRA
            <ArrowRight className="w-5 h-5 shrink-0" data-id="element-224" />
          </button>

          <p className="text-xs md:text-sm text-slate-500 mt-4" data-id="element-225">
            Acceso inmediato · Pago 100% seguro con Mercado Pago
          </p>
        </div>
      </div>
    </section>;
}